import img1 from '../../../../../assets/images/SellerPortalImages/Advertisement/Overview/img-1.png'
import img2 from '../../../../../assets/images/SellerPortalImages/Advertisement/Overview/img-2.png'
import img3 from '../../../../../assets/images/SellerPortalImages/Advertisement/Overview/img-3.png'
import Card from './Card/Card'
import styles from './Resources.module.scss'

const Resources = () => {

  const data = [
    { title: "Video", desc: "Setting Up Your Shop", image: img1 },
    { title: "Document Guide", desc: "Order Fulfillment Checklist", image: img2 },
    { title: "Document Guide", desc: "Promotional Campaign Planner", image: img3 },
  ]

  return (
    <section>
      <div className="fw-semibold fs-5 my-3">Resources</div>

      <div className={styles['wrapper']}>
        {data.map(item => (
          <Card title={item.title} desc={item.desc} image={item.image} />
        ))}
      </div>

    </section>
  )
}

export default Resources